/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsCreateCoupon
 */
export interface ControlcenterMelcoModelsCreateCoupon {
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    type?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    user_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    product_code_list?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    start_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    end_date?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    usage_count?: number;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsCreateCoupon
     */
    usage_type?: number;
}

export function ControlcenterMelcoModelsCreateCouponFromJSON(json: any): ControlcenterMelcoModelsCreateCoupon {
    return ControlcenterMelcoModelsCreateCouponFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsCreateCouponFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsCreateCoupon {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'user_id': !exists(json, 'user_id') ? undefined : json['user_id'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'product_code_list': !exists(json, 'product_code_list') ? undefined : json['product_code_list'],
        'start_date': !exists(json, 'start_date') ? undefined : (json['start_date'] === null ? null : new Date(json['start_date'])),
        'end_date': !exists(json, 'end_date') ? undefined : (json['end_date'] === null ? null : new Date(json['end_date'])),
        'usage_count': !exists(json, 'usage_count') ? undefined : json['usage_count'],
        'usage_type': !exists(json, 'usage_type') ? undefined : json['usage_type'],
    };
}

export function ControlcenterMelcoModelsCreateCouponToJSON(value?: ControlcenterMelcoModelsCreateCoupon | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'code': value.code,
        'description': value.description,
        'user_id': value.user_id,
        'value': value.value,
        'product_code_list': value.product_code_list,
        'start_date': value.start_date === undefined ? undefined : (value.start_date === null ? null : value.start_date.toISOString()),
        'end_date': value.end_date === undefined ? undefined : (value.end_date === null ? null : value.end_date.toISOString()),
        'usage_count': value.usage_count,
        'usage_type': value.usage_type,
    };
}


